export const PRINT_PDF_PEER = " PRINT_PDF_PEER";

export const PRINT_PDF_OWN = " PRINT_PDF_OWN";
export const PRINT_PDF_OWN_TA = " PRINT_PDF_OWN_TA";
export const PRINT_PDF_EVU_ADMIN = "PRINT_PDF_EVU_ADMIN";
export const PRINT_PDF_REPORT = "PRINT_PDF_REPORT";
export const PRINT_PDF_REPORT_TA = "PRINT_PDF_REPORT_TA";



// WEBPACK FOOTER //
// ./src/modules/pdf/constants.js